var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTinyPlus = function SvgTinyPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.416 4.5a.5.5 0 0 0-1 0v7h-7a.5.5 0 0 0 0 1h7v7a.5.5 0 0 0 1 0v-7h7a.5.5 0 0 0 0-1h-7v-7Z",
    fill: "#3190FF"
  })));
};
export default SvgTinyPlus;